export const DEFAULT_APP_CULTURE_CODE = 'en-US';

export interface Language {
  uId?: string | null;
  isActive?: boolean;
  cultureCode?: string | null;
  isDefault?: boolean;
  sortOrder?: number;
  isRightToLeft?: boolean;
  sortCollation?: string;
}

export interface CultureCodeWithLabel
{
  code?: string;
  label?: string;
}

export interface TranslationRequest
{
  text?: string;
  id?: string;
}

export interface TranslationResult
{
  targetLanguageCode?: string;
  text?: string;
  id?: string;
}
